module.exports = __webpack_public_path__ + "static/img/logo.748df294.png";